export const ARTICLE_READ_BUCKETS_COUNT = 10;

interface VerticalRect {
  top: number;
  bottom: number;
}

export const getVisibleBuckets = (bodyRect: VerticalRect, viewportRect: VerticalRect): number[] => {
  const height = bodyRect.bottom - bodyRect.top;
  const visibleTop = Math.max(bodyRect.top, viewportRect.top);
  const visibleBottom = Math.min(bodyRect.bottom, viewportRect.bottom);
  if (height <= 0 || visibleBottom <= visibleTop) {
    return [];
  }

  const first = Math.floor(((visibleTop - bodyRect.top) / height) * ARTICLE_READ_BUCKETS_COUNT) + 1;
  const last = Math.min(
    ARTICLE_READ_BUCKETS_COUNT,
    Math.ceil(((visibleBottom - bodyRect.top) / height) * ARTICLE_READ_BUCKETS_COUNT)
  );
  return Array.from({ length: last - first + 1 }, (_, index) => first + index);
};
